'use client';

import type { FC } from 'react';
import { useLocalTranslation } from '../hooks/useLocalTranslation';
import translations from './ErrorMessage.translations';
import { Button, Text, Title } from './ui';

interface ErrorMessageProps {
  error: string;
  message?: string;
  onRetry?: () => void;
}

export const ErrorMessage: FC<ErrorMessageProps> = ({ error, message, onRetry }) => {
  const { t } = useLocalTranslation(translations);

  return (
    <div className="max-w-[400px] mx-auto p-5 text-center">
      <div className="bg-black rounded-lg p-5 mb-4">
        <div className="text-5xl mb-4">❌</div>
        <Title level="3" weight="2">
          {t('errorOccurred')}
        </Title>
        <Text>{message || error}</Text>
      </div>

      {onRetry && (
        <Button onClick={onRetry} size="l" stretched>
          {t('retry')}
        </Button>
      )}
    </div>
  );
};
